var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sort",on:{"click":_vm.sortChange}},[_vm._v(" "+_vm._s(_vm.title)+" "),([_vm.descId, _vm.ascId].includes(_vm.value))?_c('i',{class:[
			'fa fa-long-arrow-up sort__icon',
			{
				'sort__icon--rotate': _vm.descId === _vm.value,
			},
		]}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }